import { axios } from "../utils/axios";

export interface Store {
  name: string;
  address: string;
  phone: string;
  content: string;
  posterUrl: string;
  partyRooms: number;
  dailyLimit: {
    common: [];
    coupon: [];
    dates: { date?: string; group?: string; limit?: number }[];
  };
  ip: string;
  // ticketPrinters?: TicketPrinter[];
  order: number;
  doorsInitialized?: boolean;
}

export const findStores = async () =>
  axios.request({
    url: "/store"
  });

export const getConfigs = async () => axios.request({ url: "/config" });

export const getStats = async () =>
  axios.request({
    url: "/stats"
  });
